/* Electrolytes promo auto-apply (v1.2, 2026-08-12)
   Eager model. v1.2: application is VERIFIED against the cart and retried if
   it did not attach (a single lost /discount request no longer poisons the
   session), and the checkout safety net fires on pointerdown as well as
   click for extra headroom before navigation. */
(function () {
  var ENABLED = true;
  var PRODUCT_ID = 8743149502601;
  var OT_CODE = 'ELECTROLYTES25';
  var SUB_TIERS = [
    { min: 15, code: 'ELECTROLYTES50X5' },
    { min: 12, code: 'ELECTROLYTES50X4' },
    { min: 9, code: 'ELECTROLYTES50X3' },
    { min: 6, code: 'ELECTROLYTES50X2' },
    { min: 3, code: 'ELECTROLYTES50' },
  ];
  if (!ENABLED) return;

  var lastApplied = null;
  var lastCodes = [];
  var timer = null;
  var retries = 0;

  function applyCodes(codes, keepalive) {
    codes.forEach(function (c) {
      // Sequential single-code requests; /discount/A,B is one invalid code.
      try {
        fetch('/discount/' + c, keepalive ? { keepalive: true } : {}).catch(function () {});
      } catch (e) {}
    });
  }

  function computeCodes(cart) {
    var ot = 0;
    var sub = 0;
    (cart.items || []).forEach(function (it) {
      if (it.product_id !== PRODUCT_ID) return;
      if (it.selling_plan_allocation) sub += it.quantity;
      else ot += it.quantity;
    });
    var codes = [];
    if (ot >= 3) codes.push(OT_CODE);
    for (var t = 0; t < SUB_TIERS.length; t++) {
      if (sub >= SUB_TIERS[t].min) {
        codes.push(SUB_TIERS[t].code);
        break;
      }
    }
    return codes;
  }

  function evaluateCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var codes = computeCodes(cart);
        lastCodes = codes;
        var wanted = codes.join(',');
        if (wanted === lastApplied) return;
        lastApplied = wanted;
        retries = 0;
        if (codes.length) {
          applyCodes(codes, false);
          verifySoon(wanted, codes);
        } else {
          document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
        }
      })
      .catch(function () {
        // cart fetch failed — allow a retry on the next event
        lastApplied = null;
      });
  }

  // Confirm the codes actually attached to the cart; if not, retry (max 3).
  function verifySoon(wanted, codes) {
    setTimeout(function () {
      if (lastApplied !== wanted) return; // state moved on
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var attached = (cart.discount_codes || []).map(function (c) {
            return String(c.code || '').toUpperCase();
          });
          var ok = codes.every(function (c) { return attached.indexOf(c) > -1; });
          if (!ok && retries < 3) {
            retries++;
            applyCodes(codes, false);
            verifySoon(wanted, codes);
          }
        })
        .catch(function () {});
    }, 1500);
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(evaluateCart, 150);
  }
  document.addEventListener('cart:updated', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  // Checkout-intent safety net: re-fire the known qualifying codes with
  // keepalive so the request survives navigation. pointerdown fires ~100ms+
  // before click, buying extra headroom. Never blocks navigation; re-applying
  // an already-applied code is a no-op.
  function reinforce(e) {
    if (!lastCodes.length) return;
    var t = e.target && e.target.closest
      ? e.target.closest('button[name="checkout"], input[name="checkout"], a[href^="/checkout"]')
      : null;
    if (!t) return;
    applyCodes(lastCodes, true);
  }
  document.addEventListener('pointerdown', reinforce, true);
  document.addEventListener('click', reinforce, true);
})();
